export var isReplaceShoppingBagItemErrorResponse = function (response) {
    return "isSuccess" in response && !response.isSuccess;
};
